// Copyright (c) 2022 by Move Closer

import { ModulesFormRegistryEntry } from '../contexts'

import { AvailableModuleDriver } from './allowed'
import { ContainerForm, createContainerContent } from './Container/form'

import { accordionModuleEntry } from './Accordion/form'
import { advertiseBoxModuleEntry } from './AdvertiseBox/form'
import { articlesListModuleEntry } from './ArticlesList/form'
import { articlesTeaserModuleEntry } from './ArticlesTeaser/form'
import { articleTeaserBoxEntry } from './ArticlesTeaserBox/form'
import { attachmentsListModuleEntry } from './AttachmentsList/form'
import { artisticCarouselModuleEntry } from './ArtisticCarousel/form'
import { brandTeaserModuleEntry } from './BrandTeaser/form'
import { benefitsBoxModuleEntry } from './BenefitsBox/form'
import { buttonModuleEntry } from './Button/form'
import { breadcrumbsModuleEntry } from './Breadcrumbs/form'
import { certificatesListModuleEntry } from './CertificatesList/form'
import { ctaModuleEntry } from './CTABox/form'
import { contactFormModuleEntry } from './ContactForm/form'
import { creationsModuleEntry } from './Creations/form'
import { customerSupportModuleEntry } from './CustomerSuport/form'
import { descriptionListModuleEntry } from './DescriptionList/form'
import { floatingOrderRenewalModuleEntry } from './FloatingOrderRenewal/form'
import { footerModuleEntry } from './Footer/form'
import { headingModuleEntry } from './Heading/form'
import { heroModuleEntry } from './Hero/form'
import { imageModuleEntry } from './Image/form'
import { imageListModuleEntry } from './ImageList/form'
import { navbarModuleEntry } from './Navbar/form'
import { navigationCTABoxModuleEntry } from './NavigationCTABox/form'
import { newsletterModuleEntry } from './Newsletter/form'
import { productApplicationSliderModuleEntry } from './ProductApplicationSlider/form'
import { productHeaderModuleEntry } from './ProductHeader/form'
import { productSpecificationModuleEntry } from './ProductSpecification/form'
import { productReviewsModuleEntry } from './ProductReviews/form'
import { productsListModuleEntry } from './ProductsList/form'
import { productsSetModuleEntry } from './ProductsSet/form'
import { productsTeaserModuleEntry } from './ProductsTeaser/form'
import { productsUpsellModuleEntry } from './ProductsUpsell/form'
import { profileNavModuleEntry } from './ProfileNav/form'
import { reviewsTeaserModuleEntry } from './ReviewsTeaser/form'
import { tabsModuleEntry } from './Tabs/form'
import { textModuleEntry } from './Text/form'
import { usageCalculatorModuleEntry } from './UsageCalculator/form'
import { videoModuleEntry } from './Video/form'
import { infoCardModuleEntry } from './InfoCard/form'
import { webinarsListModuleEntry } from './WebinarsList/form'
import { selenaFormModuleEntry } from './SelenaForm/form'
import { videoTeaserModuleEntry } from './VideoTeaser/form'
import { iframeModuleEntry } from './Iframe/form'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const containerFactory = createContainerContent

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const containerFormComponent = ContainerForm

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const modulesFormRegistry: Record<string, ModulesFormRegistryEntry> = {
  [AvailableModuleDriver.Accordion]: accordionModuleEntry,
  [AvailableModuleDriver.AdvertiseBox]: advertiseBoxModuleEntry,
  [AvailableModuleDriver.ArticlesList]: articlesListModuleEntry,
  [AvailableModuleDriver.ArticlesTeaser]: articlesTeaserModuleEntry,
  [AvailableModuleDriver.ArticlesTeaserBox]: articleTeaserBoxEntry,
  [AvailableModuleDriver.ArtisticCarousel]: artisticCarouselModuleEntry,
  [AvailableModuleDriver.AttachmentsList]: attachmentsListModuleEntry,
  [AvailableModuleDriver.BenefitsBox]: benefitsBoxModuleEntry,
  [AvailableModuleDriver.BrandTeaser]: brandTeaserModuleEntry,
  [AvailableModuleDriver.Breadcrumbs]: breadcrumbsModuleEntry,
  [AvailableModuleDriver.Button]: buttonModuleEntry,
  [AvailableModuleDriver.CertificatesList]: certificatesListModuleEntry,
  [AvailableModuleDriver.CTABox]: ctaModuleEntry,
  [AvailableModuleDriver.ContactForm]: contactFormModuleEntry,
  [AvailableModuleDriver.Creations]: creationsModuleEntry,
  [AvailableModuleDriver.CustomerSupport]: customerSupportModuleEntry,
  [AvailableModuleDriver.DescriptionList]: descriptionListModuleEntry,
  [AvailableModuleDriver.FloatingOrderRenewal]: floatingOrderRenewalModuleEntry,
  [AvailableModuleDriver.Footer]: footerModuleEntry,
  [AvailableModuleDriver.Heading]: headingModuleEntry,
  [AvailableModuleDriver.Hero]: heroModuleEntry,
  [AvailableModuleDriver.Iframe]: iframeModuleEntry,
  [AvailableModuleDriver.Image]: imageModuleEntry,
  [AvailableModuleDriver.ImageList]: imageListModuleEntry,
  [AvailableModuleDriver.InfoCard]: infoCardModuleEntry,
  [AvailableModuleDriver.Navbar]: navbarModuleEntry,
  [AvailableModuleDriver.NavigationCTABox]: navigationCTABoxModuleEntry,
  [AvailableModuleDriver.Newsletter]: newsletterModuleEntry,
  [AvailableModuleDriver.ProductApplicationSlider]: productApplicationSliderModuleEntry,
  [AvailableModuleDriver.ProductHeader]: productHeaderModuleEntry,
  [AvailableModuleDriver.ProductReviews]: productReviewsModuleEntry,
  [AvailableModuleDriver.ProductsList]: productsListModuleEntry,
  [AvailableModuleDriver.ProductsSet]: productsSetModuleEntry,
  [AvailableModuleDriver.ProductSpecification]: productSpecificationModuleEntry,
  [AvailableModuleDriver.ProductsTeaser]: productsTeaserModuleEntry,
  [AvailableModuleDriver.ProductsUpsell]: productsUpsellModuleEntry,
  [AvailableModuleDriver.ProfileNav]: profileNavModuleEntry,
  [AvailableModuleDriver.ReviewsTeaser]: reviewsTeaserModuleEntry,
  [AvailableModuleDriver.Tabs]: tabsModuleEntry,
  [AvailableModuleDriver.Text]: textModuleEntry,
  [AvailableModuleDriver.SelenaForm]: selenaFormModuleEntry,
  [AvailableModuleDriver.UsageCalculator]: usageCalculatorModuleEntry,
  [AvailableModuleDriver.Video]: videoModuleEntry,
  [AvailableModuleDriver.VideoTeaser]: videoTeaserModuleEntry,
  [AvailableModuleDriver.WebinarsList]: webinarsListModuleEntry
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export function resolveModulesFormRegistry (allowed: string[]): Record<string, ModulesFormRegistryEntry> {
  if (allowed.length === 0) {
    return modulesFormRegistry
  }

  const filteredRegistry: Record<string, ModulesFormRegistryEntry> = {}
  for (const a of allowed) {
    if (!modulesFormRegistry[a]) {
      continue
    }

    filteredRegistry[a] = modulesFormRegistry[a]
  }

  return filteredRegistry
}
